/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReleasePrinterLockDto
 */
export interface ReleasePrinterLockDto {
    /**
     * 
     * @type {string}
     * @memberof ReleasePrinterLockDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof ReleasePrinterLockDto
     */
    clientId: string;
}

/**
 * Check if a given object implements the ReleasePrinterLockDto interface.
 */
export function instanceOfReleasePrinterLockDto(value: object): value is ReleasePrinterLockDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function ReleasePrinterLockDtoFromJSON(json: any): ReleasePrinterLockDto {
    return ReleasePrinterLockDtoFromJSONTyped(json, false);
}

export function ReleasePrinterLockDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleasePrinterLockDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'clientId': json['clientId'],
    };
}

export function ReleasePrinterLockDtoToJSON(value?: ReleasePrinterLockDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'url': value['url'],
        'clientId': value['clientId'],
    };
}

